import { fonts } from './fonts.js'
import { getHeadlessPool } from './headless-pool-for-board.js'
import { headlessModel } from './headless-model.js'

const protocol = 'http'
const host = 'localhost'
const path = '/internal-board-service-view'

export const screenshot = async ({
  id = '',
  model = null,
  data = null,
  width: w = 0,
  height: h = 0,
  options = { encoding: 'base64' } as any,
  isThumbnail = false,
  context = {} as any,
  draft = false
} = {}) => {
  const browser = (await getHeadlessPool().acquire()) as any
  var screenshot = null

  if (!browser) {
    return
  }
  const { domain, user } = context.state

  var { model, base } = await headlessModel({ domain, id, model }, draft)
  const [fontsToUse, fontStyles] = await fonts(domain)

  model.fonts = fontsToUse
  model.fontStyles = fontStyles

  var { width, height } = model

  if (isThumbnail) {
    var widthRatio = 400 / width,
      heightRatio = 300 / height
    var ratio = widthRatio < heightRatio ? widthRatio : heightRatio
    width = width * ratio
    height = height * ratio
  }
  width = Math.floor(w || Number(width))
  height = Math.floor(h || Number(height))

  const port = process.env.PORT ? `:${process.env.PORT}` : ''
  const url = `${protocol}://${host}${port}${path}`

  var page = await browser.newPage()

  try {
    /* @remember-me width, height should be a integer */
    await page.setViewport({ width, height })
    await page.setRequestInterception(true)
    await page.setDefaultTimeout(10000)

    page.on('console', async msg => {
      console.log(`[headless ${msg.type()}] ${msg.text()}`)
    })

    page.on('pageerror', error => {
      console.log(`[headless pageerror] ${error.message}`)
      console.log(error.stack)
    })

    page.on('error', error => {
      console.log(`[headless fault] ${error}`)
      console.log(error.stack)
    })

    page.on('requestfailed', request => {
      console.log('Request failed:', request.url())
    })

    const token = await user?.sign() // TODO improve performance

    page.on('request', request => {
      if (request.url() === url) {
        request.continue({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-things-factory-domain': domain?.subdomain,
            Authorization: 'Bearer ' + token
          },
          postData: JSON.stringify({
            model,
            base
          })
        })
      } else if (request.url().startsWith(`${protocol}://${host}${port}`)) {
        request.continue({
          headers: {
            ...request.headers(),
            'x-things-factory-domain': domain?.subdomain,
            Authorization: 'Bearer ' + token
          }
        })
      } else {
        request.continue()
      }
    })
    await page.goto(url)

    await page.evaluate(async data => {
      if (data) {
        // @ts-ignore
        s.data = data
      }

      // data 주입 후 강제 지연시킴.
      return new Promise(resolve => {
        // @ts-ignore
        requestAnimationFrame(() => resolve())
      })
    }, data)

    screenshot = await page.screenshot(options)
  } catch (error) {
    console.log(error)
  } finally {
    page.close()
    getHeadlessPool().release(browser)
  }

  return screenshot
}
